export default {
  lang_chooser: {
    aria_label: 'Sélecteur de langue',
    lang_switch: 'Navigate in',
  },
};
